module.exports = __webpack_public_path__ + "static/img/101.37e7f90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/201224/101.jpg
// module id = Uw+u
// module chunks = 0